import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { LOGOS } from "@/lib/assets";

/**
 * Widerruf der Cookie-Einwilligung gemäß Art. 7 Abs. 3 DSGVO.
 * Feuert ein globales Event; der CookieConsentBanner löscht daraufhin
 * den gespeicherten Consent aus dem LocalStorage und öffnet sich erneut.
 */
function reopenCookieBanner() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("feaststar:cookie-reopen"));
}

export default function Footer({ variant = "home" }) {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-soft bg-bg mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-3 gap-8 items-center">
        <Link to="/" aria-label="Feaststar" className="inline-flex items-center">
          <img src={LOGOS.wordmark} alt="Feaststar" className="h-9 w-auto feaststar-logo" draggable="false" />
        </Link>
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm">
          {variant === "home" ? (
            <>
              <a href="#download" className="text-primary hover:text-accent">{t("home.footer.cols.app")}</a>
              <a href="#restaurant-origin" className="text-primary hover:text-accent">{t("home.footer.cols.restaurantSelect")}</a>
              <Link to="/partner" className="text-primary hover:text-accent">{t("home.footer.cols.partner")}</Link>
            </>
          ) : (
            <Link to="/" className="text-primary hover:text-accent">{t("nav.forGuests")}</Link>
          )}
        </div>
        <div className="flex flex-wrap md:justify-end justify-center gap-4 text-sm">
          <Link to="/impressum" data-testid="footer-imprint" className="text-muted hover:text-primary">{t("home.footer.cols.imprint")}</Link>
          <Link to="/datenschutz" data-testid="footer-privacy" className="text-muted hover:text-primary">{t("home.footer.cols.privacy")}</Link>
          <button
            type="button"
            onClick={reopenCookieBanner}
            data-testid="footer-cookie-settings"
            className="text-muted hover:text-primary bg-transparent border-0 p-0 cursor-pointer"
            aria-label="Cookie-Einstellungen ändern"
          >
            Cookie-Einstellungen
          </button>
          <span className="text-muted">© {new Date().getFullYear()} Feaststar</span>
        </div>
      </div>
    </footer>
  );
}
